<template>
    <v-list id="account-switch-container" v-if="activeAccounts.length > 1">
        <span class="label">Your organisations:</span>
        <v-list-item v-for="activeAccount in activeAccounts" :key="activeAccount.id"
                     @click="onAccountSwitch(activeAccount.id)"
        >
            <span class="organization-name mr-3" :class="{ active: activeAccount.id == account.id }">
                {{ activeAccount.organization.name }}
            </span>
        </v-list-item>
    </v-list>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
    computed: {
        ...mapState("User", ["account"]),
        activeAccounts() {
            let accounts = this.$store.getters['User/activeAccounts'];
            return accounts.filter(account => account.organization && !account.suspended_at);
        },
    },
    methods: {
        onAccountSwitch(id) {
            if (id == this.account.id) return;

            this.$store.dispatch("User/switchAccount", id);
        },
    },
};
</script>

<style lang="scss">
#account-switch-container.v-list {
    background: var(--dark-gray);
    padding: 25px 0;
    border-radius: var(--box-rounding);
    padding: 0;

    .label {
        padding: 25px;
        line-height: 1.2;
        font-size: 12px;
        color: #989898;
    }

    .v-list-item {
        display: flex;
        min-height: 24px;
        padding: 0 25px;
        font-size: 12px;

        .organization-name {
            color: #989898;
            line-height: 2;

            &.active {
                color: var(--primary);
            }
        }

        .notification-counter {
            margin-left: auto;
        }
    }
}
</style>
